export default "__VITE_ASSET__D2blMC4c__"